import React from "react";
import ThemeTogglerTwo from "../../components/common/ThemeTogglerTwo";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    // No background of its own. This painted `bg-gray-50 dark:bg-gray-900`
    // over the body's own ground, which is how the first screen anybody sees
    // ended up being the one screen that missed the re-skin: every other page
    // shows `--color-paper`, and this one showed the colour that preceded it.
    // The body owns the ground in both themes; nothing else repaints it.
    <div className="flex min-h-screen flex-col items-center justify-center px-4">
      {/* Logo + app name */}
      <div className="mb-8 text-center">
        {/* font-display, like every other page title in the app. `PageBreadCrumb`
            is the h1 treatment everywhere behind the login; this is the h1 in
            front of it and was the one heading set in the body face. */}
        <h1 className="font-display text-title-sm font-semibold tracking-tight text-gray-900 dark:text-white">
          Poultry Book
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Farm management made simple
        </p>
      </div>

      {/* The one card surface, not a hand-rolled copy of it. The copy had its
          own radius, its own border and `dark:bg-gray-800` where the shared
          surface is a light wash — so it read as a different material from
          every card behind the login. */}
      <div className="card w-full max-w-sm p-6 sm:p-8">
        {children}
      </div>

      {/* Theme toggle */}
      <div className="fixed z-50 bottom-6 right-6 hidden sm:block">
        <ThemeTogglerTwo />
      </div>
    </div>
  );
}
